import { Pencil, Settings, Trash2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { User } from '@/types/user'

interface CompanyUsersTabProps {
	users: User[]
	loading: boolean
	onCreate: () => void
	onEdit: (user: User) => void
	onDelete: (userId: string) => void
	onOptions?: (user: User) => void
}

export function CompanyUsersTab({ users, loading, onCreate, onEdit, onDelete, onOptions }: CompanyUsersTabProps) {
	return (
		<Card>
			<CardHeader>
				<div className="flex items-center justify-between">
					<CardTitle>Usuarios</CardTitle>
					<Button disabled={loading} onClick={onCreate}>
						Crear usuario
					</Button>
				</div>
			</CardHeader>
			<CardContent>
				{loading ? (
					<div className="space-y-3">
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</div>
				) : (
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Código</TableHead>
								<TableHead>Nombre</TableHead>
								<TableHead>Email</TableHead>
								<TableHead>Tipo de usuario</TableHead>
								<TableHead className="w-24">Acciones</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{users.length === 0 ? (
								<TableRow>
									<TableCell colSpan={5} className="text-center text-muted-foreground">
										No hay usuarios
									</TableCell>
								</TableRow>
							) : (
								users.map((user) => (
									<TableRow key={user.id}>
										<TableCell>{user.code}</TableCell>
										<TableCell className="font-medium">{user.name}</TableCell>
										<TableCell>{user.email || '-'}</TableCell>
										<TableCell>
											<div className="flex gap-2">
												{user.isManager && <Badge variant="secondary">Manager</Badge>}
												{user.isEmployee && <Badge variant="outline">Empleado</Badge>}
											</div>
										</TableCell>
										<TableCell>
											<div className="flex gap-2">
												{onOptions && (
													<Button variant="ghost" size="icon" onClick={() => onOptions(user)}>
														<Settings className="h-4 w-4" />
													</Button>
												)}
												<Button variant="ghost" size="icon" onClick={() => onEdit(user)}>
													<Pencil className="h-4 w-4" />
												</Button>
												<Button variant="ghost" size="icon" onClick={() => onDelete(user.id)}>
													<Trash2 className="h-4 w-4 text-destructive" />
												</Button>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				)}
			</CardContent>
		</Card>
	)
}
